import { useContext } from 'react';

import { isDefined } from '@hsp/utilities';

import { TableContext } from 'components/table/context/table.context';

export const useTableStoreSet = () => {
  const store = useContext(TableContext);

  if (!isDefined(store)) {
    throw new Error('Store not found');
  }

  return store.set;
};
